
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Badge from 'vux/src/components/badge/index.vue'

import footer01 from '../../assets/ico-menu1.png'
import footer02 from '../../assets/ico-menu2.png'
import footer03 from '../../assets/ico-menu3.png'
import footer04 from '../../assets/ico-menu4.png'
import footer001 from '../../assets/ico-menu1on.png'
import footer002 from '../../assets/ico-menu2on.png'
import footer003 from '../../assets/ico-menu3on.png'
import footer004 from '../../assets/ico-menu4on.png'
import icoEmail from '../../assets/ico-menu-ghfw1.png'
import icoLaw from '../../assets/ico-menu-ghfw2.png'
import icoYizhen from '@/assets/icon_xianshangyizhen.png'
import pengcheng from '@/assets/yz/pengcheng.png'
import zhigongxiaojia from '@/assets/yz/zhigongxiaojia.png'
import yiliaohuzhu from '@/assets/yz/yiliaohuzhu.png'
import icoMmxw from '@/assets/ico-mmxw.png'
import ico3 from '@/assets/yz/yzHome-09.png'
import { myDeal } from '@/api/youzheng.js'
import { isWorker, getDealList } from '@/api/zhigongxiaojia.js'
export default {
name: '',
props: {
num: Number
},
directives: {
TransferDom
},
data () {
return {
footer01: footer01,
footer02: footer02,
footer03: footer03,
footer04: footer04,
footer001: footer001,
footer002: footer002,
footer003: footer003,
footer004: footer004,
icoMmxw: icoMmxw,
icoYizhen: icoYizhen,
pengcheng: pengcheng,
zhigongxiaojia: zhigongxiaojia,
yiliaohuzhu: yiliaohuzhu,
icoLaw: icoLaw,
ico3: ico3,
icoEmail: icoEmail,
index: 0,
show: false,
accounttype: this.$store.state.user.personObj.accounttype,
idtype: 2,
isqyb: this.$store.state.user.personObj.isqyb,
total: 0
}
},
components: {
Tabbar,
TabbarItem,
Popup,
Badge
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
opendiv () {
this.show = true
},
getmyDeal () {
if (this.accounttype === 4) {
this.idtype = 1
}
myDeal({
accountid: this.accountid,
idtype: this.idtype,
userid: this.userid
}).then(res => {
this.total = res.obj.total
this.lawyerNum = res.obj.lawyerNum
this.mailboxNum = res.obj.mailboxNum
})
}





















},
activated () { },
created () {
this.getmyDeal()

this.index = this.num
}
}
